import React from 'react';
import moment from 'moment';


export const options = {
  columns: [

    { id: 1, name: 'platforms', label: 'PLATFORM', sortable: true, type: 'string' },
    { id: 2, name: 'name', label: 'CAMPAIGN/STRATEGY NAME', sortable: true, type: 'string',expand: true, },
    { id: 3, name: 'type', label: 'CREATIVE TYPE', sortable: true, type: 'string', component: (row) => row.type == 0 ? "Display" : row.type == 1 ? "Video" : row.type == 2 ? "Search" :row.type == 3 ? "Display, Video" : '-' },
    { id: 4, name: 'budget', label: 'BUDGET', sortable: true, type: 'number' },
    // { id: 5, name: 'type', label: 'BUDGET TYPE', sortable: true, type: 'number' },
    { id: 6, name: 'startDate', label: 'START DATE', sortable: true, type: 'date', component: row => moment(row.startDate ? row.startDate : row.sDate ? row.sDate:'').format('D-MMM-YY') },
    { id: 7, name: 'endDate', label: 'END DATE', sortable: true, type: 'date', component: row => moment(row.endDate ? row.endDate : row.eDate ? row.eDate:'').format('D-MMM-YY') },
    // { id: 8, name: 'status', label: 'STATUS', sortable: true, type: 'string', component: (row) => row.status == 1 ? <p className='badge bg-label-success'>Active</p> : row.status == 0 ? <p className='badge bg-label-danger'>Inactive</p> : <p className='badge bg-label-warning'>Draft</p> },
    { id: 8, name: 'status', label: 'STATUS', sortable: true, type: 'string', component: (row) => row.status == 1 ? <span className='text-success'>Active</span> : row.status == 0 ? <span className='text-danger'>InActive</span> :  <span className='text-warning'>Draft</span> },
    // { id: 10, name: 'recos', label: 'RECOM...', sortable: true, type: 'number', component: (row) => <div class="d-flex align-items-center">{row.recos} <a href={row.recos}><i class="ti ti-external-link ti-xs pl-1 text-primary"></i></a> </div> }

  ],
  keyCol: 'campaignId',
  actions: [
  //   {
  //   type: 'edit',
  //   text: '',
  //   icon: 'ti ti-pencil color-beki',
  //   tooltip: 'Edit'
  // },
  {
    type: 'chart',
    text: '',
    icon: 'ti ti-chart-bar color-beki',
    tooltip: 'View Campign',
  },],
  recActive: true,
  status: {
    key: 'status',
    active: '1',
    activeIcon: 'ti ti-toggle-left color-beki ti-lg',
    inActiveIcon: 'ti ti-toggle-right color-beki ti-lg',
    confirmation: true,
    activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
    inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
  },
  actionsThead: true,
  sortable: true,
  dateType: true,
  searchable: true,
  searchColumns: [
    { key: 'Date', func: (row) => moment(row.Date, 'YYYY-MM-DD').format('D-MMM-YY') },
    { key: 'domain' },
    { key: 'partner' },
    { key: 'adUnitId' },
    { key: 'totalAdReq' },
    { key: 'property' },
    { key: 'totalAdRes' },
    { key: 'resRate' },
    { key: 'totalAdServed' },
    { key: 'fillRate' },
    { key: 'totalRevenue' },
    { key: 'eCPM' }
  ],
  defaultSortParams: {
    sortBy: 'Date',
    sortOrder: 'desc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 25
  },
  // CSVDownload: {
  //   type: 'mediaReport',
  //   showCSVButton: true,
  //   buttonName: 'Download',
  //   saveFileName: 'MediaReport'
  // }
}